import React from "react";
import { BrainCircuit, RefreshCw } from "lucide-react";

const DashboardHeader = ({ onRefresh, loading }) => {
  return (
    <header className="bg-white border-b border-slate-200 top-0 z-30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="bg-gradient-to-br from-blue-600 to-indigo-600 p-2 rounded-lg text-white shadow-lg shadow-blue-200">
            <BrainCircuit size={20} />
          </div>
          <div>
            <h1 className="text-lg font-bold text-slate-900 flex items-center gap-2">
              AI Revenue
              <span className="px-2 py-0.5 rounded-full bg-green-100 text-green-700 text-xs font-bold border border-green-200">
                Live API
              </span>
            </h1>
            <p className="text-xs text-slate-500">Dữ liệu thời gian thực</p>
          </div>
        </div>
        <div className="flex items-center gap-4">
          <button
            className="p-2 text-slate-500 hover:bg-slate-100 rounded-lg transition-colors"
            onClick={onRefresh}
            disabled={loading}
          >
            <RefreshCw size={18} className={loading ? "animate-spin" : ""} />
          </button>
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;